import times from 'lodash/times'

import { IQuestion, MAX_NUM_OF_QUESTION_OPTIONS, QuestionType } from 'cat-shared/utils'

import { CreateQuestionFormValues, QuestionSubmitFormValues } from 'client/utils'

export const getCreateQuestionInitialValues = (
  type = QuestionType.SingleChoice,
  category = '',
  text = ''
): CreateQuestionFormValues => {
  const numOfOptions = 2

  const values = {
    type,
    category,
    text,
    numOfOptions,
    options: {},
    correctOptions: [],
    explanation: '',
  } as CreateQuestionFormValues

  times(MAX_NUM_OF_QUESTION_OPTIONS, i => {
    values.options[i + 1] = ''
  })

  return values
}

export const getSubmitQuestionInitialValues = (
  question?: IQuestion
): QuestionSubmitFormValues => {
  const values = {
    votes: {},
  }

  times(question?.options.length, i => {
    values.votes[i] = false
  })

  if (question?.answeredStats) {
    times(question.answeredStats.byRequestor.length, i => {
      values.votes[question.answeredStats.byRequestor[i]] = true
    })
  }

  return values
}
